import { FC, useContext, useEffect, useRef } from "react";
import NotificationDispatch, { showErrorNotification } from "../../../../../context/notificationContext";
import useI18n from "../../../../../hooks/useTranslations";
import { useUprightCapsApi } from "../../../../../http/border/useUprightCaps";
import UprightCapForm from "./UprightCapForm";

interface EditUprightCapProps {
  onClose: () => void;
  uprightCapId: string;
}

const EditUprightCap: FC<EditUprightCapProps> = ({ onClose, uprightCapId }) => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const aborter = useRef(new AbortController());
  const uprightCapsApi = useUprightCapsApi();

  const { data, error, trigger } = uprightCapsApi.getAdminUprightCap(uprightCapId, aborter.current.signal);

  useEffect(() => {
    error && dispatch(showErrorNotification(i18n, error));
  }, [error]);

  useEffect(() => {
    uprightCapId && trigger();
  }, [uprightCapId]);

  return (
    <UprightCapForm
      onClose={onClose}
      uprightCap={data}
      isDisabled={!!error}
      isLoading={!data && !error}
    />
  );
};

export default EditUprightCap;
